module.exports = __webpack_public_path__ + "static/iphone@2x-903d0fb7c701b3516f399a9e634c92d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/sketches/iphone@2x.png
// module id = 930
// module chunks = 173944852332284 271422636699454